import { formatPriceForLocale } from '@/lib/pricing';

/**
 * Meerprijs of korting van een optiewaarde, overal in dezelfde vorm: "+€ 10,52"
 * of "−€ 6,38". Met harde spaties, zodat het teken nooit los op een regel valt,
 * en een echt minteken in plaats van een streepje.
 */
export function formatOptionPriceDelta(modifier: number, locale: string): string {
  if (!Number.isFinite(modifier) || modifier === 0) return '';
  const amount = formatPriceForLocale(Math.abs(modifier), locale).replace(/\s/g, ' ');
  return `${modifier > 0 ? '+' : '−'}${amount}`;
}
